import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html'
})

export class ConfirmationModalComponent {
    public body: string;
    public title: string;

    public onConfirm: Subject<any> = new Subject<any>();
    public onCancel: Subject<any> = new Subject<any>();
    public onClose: Subject<any> = new Subject<any>();

    constructor() { }

    public confirm(): void {
        this.onConfirm.next();
    }

    public cancel(): void {
        this.onCancel.next();
    }

    public close(): void {
        this.onClose.next();
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/confirmation-modal/confirmation-modal.component.ts